import React, { useMemo } from 'react';
import SelectField from 'Shared/form/SelectField';
import * as R from 'ramda';
import pathOrDash from 'App/utils/pathOrDash';
import PropTypes from 'prop-types';

const propTypes = {
    row: PropTypes.shape({
        original: PropTypes.shape({
            medicationId: PropTypes.string.isRequired,
            rx: PropTypes.shape({
                rxNumber: PropTypes.string,
            }),
            medication: PropTypes.shape({
                rxNumbers: PropTypes.arrayOf(
                    PropTypes.shape({
                        id: PropTypes.number,
                        rxNumber: PropTypes.string,
                    })
                ),
            }),
        }).isRequired,
    }).isRequired,
};

const defaultProps = {};

const RXCell = ({ row }) => {
    const options = useMemo(() => row.original.medication?.rxNumbers || [], [row]);

    if (row.original.rx || options.length === 0) {
        return <span>{pathOrDash(['original', 'rx', 'rxNumber'], row)}</span>;
    }

    if (Array.isArray(options) && options.length === 1) {
        return <span>{R.path(['original', 'medication', 'rxNumbers', 0, 'rxNumber'], row)}</span>;
    }

    return (
        <SelectField
            name={`medications.${row.original.medicationId}.rxNumber`}
            fieldName={`medications.${row.original.medicationId}.rxNumber`}
            options={options}
            getOptionValue={R.prop('id')}
            getOptionLabel={R.prop('rxNumber')}
            required
        />
    );
};

RXCell.propTypes = propTypes;
RXCell.defaultProps = defaultProps;

export default RXCell;
